import React from 'react';
import injectSheet from 'react-jss'
import {center} from "../../style/globalStyles";
import {LINKS} from "../../../constants";
import PropTypes from 'prop-types';
import {School, People, Book} from 'material-ui-icons'

const propTypes = {
    closeSidebar: PropTypes.func.isRequired
};

const style = {
    sideBarOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: '1000'
    },
    '@keyframes animate-side-bar': {
        '0%': {
            marginLeft: '-250px'
        },
        '100%': {
            marginLeft: 0
        }
    },
    sideBar: {
        top: 0,
        left: 0,
        height: '100%',
        width: '250px',
        backgroundColor: 'white',
        borderRight: 'grey 1px solid',
        animation: 'animate-side-bar 0.3s forwards',
        paddingTop: '55px'
    },
    link: {
        padding: '10px',
        width: '100%',
        color: '#00008b',
        cursor: 'pointer',
        transition: 'background-color 0.5s',
        '&:hover': {
            backgroundColor: 'lightgrey'
        },
        '& a': {
            textDecoration: 'none'
        }
    },
    linkText: Object.assign({
        marginLeft: '10px',
        fontWeight: '300'
    }, center())
};

class Sidebar extends React.Component {

    constructor(props){
        super(props);
        this.closeSidebar = this.closeSidebar.bind(this)
    }

    closeSidebar() {
        this.props.closeSidebar();
    }

    render() {
        const {classes} = this.props;
        return (

            <div className={classes.sideBarOverlay} onClick={this.closeSidebar}>
                <div className={classes.sideBar}>
                        <ul>

                            <li className={classes.link}>
                                <a href={LINKS.TEAM}>
                                    <div style={{display: 'inline-flex'}}>
                                        <div><People/></div>
                                        <h3 className={classes.linkText}>Team</h3>
                                    </div>
                                </a>
                            </li>
                            <li className={classes.link}>
                                <a href={LINKS.KNOWLADGE_BASE}>
                                    <div style={{display: 'inline-flex'}}>
                                        <div><School/></div>
                                        <h3 className={classes.linkText}> Knowledge Base</h3>
                                    </div>
                                </a>
                            </li>
                            <li className={classes.link}>
                                <a href={LINKS.BLOG}>
                                    <div style={{display: 'inline-flex'}}>
                                        <div><Book/></div>
                                        <h3 className={classes.linkText}>Blog</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                </div>
            </div>
        )
    }
}

Sidebar.propTypes = propTypes;

export default injectSheet(style)(Sidebar)



// WEBPACK FOOTER //
// ./src/app/components/AppBar/Sidebar.jsx